import { render, staticRenderFns } from "./CartComponent.vue?vue&type=template&id=177c298a&scoped=true&"
import script from "./CartComponent.vue?vue&type=script&lang=js&"
export * from "./CartComponent.vue?vue&type=script&lang=js&"
import style0 from "./CartComponent.vue?vue&type=style&index=0&id=177c298a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "177c298a",
  null
  
)

export default component.exports